//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/Section.js";
import "../no/SelectFaceList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BoxOffset",0,"Expression",0],[1,"Clearance",0,"Expression",0],[0,"GenerateType",1,0],[1,"Height",0,"Expression",0],[0,"InsertComponent",1,"TaggedObject",0],[1,"InsertToDelete",0,"Assemblies.SelectComponentList",0],[1,"InsertToEdit",0,"Assemblies.SelectComponent",0],[1,"NegativeX",0,"Expression",0],[1,"NegativeY",0,"Expression",0],[1,"NegativeZ",0,"Expression",0],[0,"NormalRenameDialog",1,0],[0,"OrientationReferenceCSYS",1,0],[1,"OuterProfile",0,"Section",0],[0,"ParentPart",1,0],[0,"ParentPartName",1,0],[1,"PositiveX",0,"Expression",0],[1,"PositiveY",0,"Expression",0],[1,"PositiveZ",0,"Expression",0],[1,"Radius",0,"Expression",0],[0,"ReverseInsertDirection",1,0],[1,"SelectFace",0,"SelectFaceList",0],[0,"SettingWithoutFalseBody",1,0],[0,"SideAttributeValue",1,0],[1,"StartPosition",0,"Expression",0],[0,"Type",1,0],[0,"UserDefinedExtrudeDirection",1,0],[0,"WizardType",1,0]],[[[],"CreateDatum",{},0,0],[[],"AddFromSpreadsheetAttributeList",{},0,0],[[],"NewAttribute",{},0,0],[[],"DeleteAttribute",{},0,0],[["numTitle","titleName"],"GetAttributeTitleName",{},0,0],[["titleName"],"SetAttributeTitleName",{},1,0],[["numText","valueText"],"GetAttributeValueText",{},0,0],[["valueText"],"SetAttributeValueText",{},1,0],[["refset"],"CreateUserDefinedInsert",{},1,0],[[],"CreateOffsetDatumPlane",{},0,0]],[]];
SPLM.Tooling.GeneralInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.GeneralInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.GeneralInsertBuilder.Types = Object.freeze({
    "CreateInsert" : "CreateInsert", "EditInsert" : "EditInsert", "DeleteInsert" : "DeleteInsert"});

SPLM.Tooling.GeneralInsertBuilder.ParentOption = Object.freeze({
    "NoParent" : "NoParent"});

SPLM.Tooling.GeneralInsertBuilder.GenerateMethod = Object.freeze({
    "BoundingBox" : "BoundingBox", "UserDefined" : "UserDefined"});

SPLM.Tooling.GeneralInsertBuilder.SideAttributeValues = Object.freeze({
    "None" : "None", "Top" : "Top", "Middle" : "Middle", "Bottom" : "Bottom"});

export default SPLM;